import { IconButton, Tooltip, type SxProps, type Theme } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/** Small hover-help affordance for nudging users toward a feature (usually a
 * slash command) they might not otherwise discover. Matches the existing
 * Tooltip + IconButton + HelpOutlineIcon pattern already used for the
 * "Start Guided Tour" hint (meeting/MeetingDetails/TopHeader.tsx). */
export default function HelpHint({ text, sx }: { text: string; sx?: SxProps<Theme> }) {
  return (
    <Tooltip title={text}>
      <IconButton size="small" aria-label="Help" sx={sx}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
